module.exports = __webpack_public_path__ + "img/curved-rail-vertical-left-top-backplates.c20e8f1b.png";